import { Helmet } from 'react-helmet';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

// Components
import AlertsTotal from '../../components/AlertsTotal/AlertsTotal';
import AssetsOverview from '../../components/AssetsOverview/AssetsOverview';

// Constants
import { APP_TITLE } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import DevicesOverview from '../../components/DevicesOverview/DevicesOverview';
import TicketsOverview from '../../components/TicketsOverview/TicketsOverview';
import HealthOverview from '../../components/HealthOverview/HealthOverview';
import { WidgetsState } from '../../Interfaces/Overview/WidgetsState';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { fetchActiveNodeTypeCounts } from '../../store/Assets/AssetsActions';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
    },
    fixedHeightAlerts: {
      height: '500',
    },
    devices: {
      width: '600',
      height: 'auto',
    },
    row: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    rowPadding: {
      padding: 5,
    },
  }),
);

export default function Overview() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeightAlerts);
  const devicesWidget = clsx(classes.paper, classes.devices);

  const widgetsState: WidgetsState[] = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.widgetsState,
  );

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      fetchActiveNodeTypeCounts(dispatch);
    }
    return () => {};
  }, [isLogin]);

  const AssetsOverviewWidget = () => {
    return (
      <div className={classes.rowPadding}>
        <Paper className={fixedHeightPaper}>
          <AssetsOverview />
        </Paper>
      </div>
    );
  };

  const DevicesOverviewWidget = () => {
    return (
      <div className={classes.rowPadding}>
        <Paper className={devicesWidget}>
          <DevicesOverview />
        </Paper>
      </div>
    );
  };

  const HealthOverviewWidget = () => {
    return (
      <div className={classes.rowPadding}>
        <Paper className={fixedHeightPaper}>
          <HealthOverview />
        </Paper>
      </div>
    );
  };

  const AlertsOverviewWidget = () => {
    return (
      <div className={classes.rowPadding}>
        <Paper className={fixedHeightPaper}>
          <AlertsTotal />
        </Paper>
      </div>
    );
  };

  const TicketsOverviewWidget = () => {
    return (
      <div className={classes.rowPadding}>
        <Paper className={fixedHeightPaper}>
          <TicketsOverview />
        </Paper>
      </div>
    );
  };

  const Widgets = () => {
    return (
      <div className={classes.row}>
        {widgetsState.map((widget, index) =>
          widget.id == ApiEnums.Widgets.AssetsSummary && widget.visible ? (
            <AssetsOverviewWidget key={widget.id} />
          ) : widget.id == ApiEnums.Widgets.DeviceStatusSummary &&
            widget.visible ? (
            <DevicesOverviewWidget key={widget.id} />
          ) : widget.id == ApiEnums.Widgets.HealthSummary && widget.visible ? (
            <HealthOverviewWidget key={widget.id} />
          ) : widget.id == ApiEnums.Widgets.AlertsSummary && widget.visible ? (
            <AlertsOverviewWidget key={widget.id} />
          ) : widget.id == ApiEnums.Widgets.TicketsSummary && widget.visible ? (
            <TicketsOverviewWidget key={widget.id} />
          ) : null,
        )}
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_OVERVIEW')} | {APP_TITLE}
        </title>
      </Helmet>
      <div className={classes.container}>
        <Widgets />
      </div>
    </>
  );
}
